
const CategoryInformation = (props) => {
    return (props &&
        <>
            {props.CategoryID &&
                <input type='hidden' id='gtm-categoryID' value={props.CategoryID} />}
            {props.CategoryName &&
                <input type='hidden' id='gtm-categoryName' value={props.CategoryName} />}
        </>
    );
}

export default CategoryInformation;